/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingSubscription } from './BillingSubscription';
import {
    BillingSubscriptionFromJSON,
    BillingSubscriptionFromJSONTyped,
    BillingSubscriptionToJSON,
    BillingSubscriptionToJSONTyped,
} from './BillingSubscription';

/**
 * 
 * @export
 * @interface ResumeBillingSubscriptionResponse
 */
export interface ResumeBillingSubscriptionResponse {
    /**
     * 
     * @type {BillingSubscription}
     * @memberof ResumeBillingSubscriptionResponse
     */
    data: BillingSubscription;
}

/**
 * Check if a given object implements the ResumeBillingSubscriptionResponse interface.
 */
export function instanceOfResumeBillingSubscriptionResponse(value: object): value is ResumeBillingSubscriptionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResumeBillingSubscriptionResponseFromJSON(json: any): ResumeBillingSubscriptionResponse {
    return ResumeBillingSubscriptionResponseFromJSONTyped(json, false);
}

export function ResumeBillingSubscriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResumeBillingSubscriptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingSubscriptionFromJSON(json['data']),
    };
}

  export function ResumeBillingSubscriptionResponseToJSON(json: any): ResumeBillingSubscriptionResponse {
      return ResumeBillingSubscriptionResponseToJSONTyped(json, false);
  }

  export function ResumeBillingSubscriptionResponseToJSONTyped(value?: ResumeBillingSubscriptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingSubscriptionToJSON(value['data']),
    };
}

